export type ReminderStatus =
  | 'pending'
  | 'soft_reminder_shown'
  | 'snoozed'
  | 'dismissed';

export type Reminder = {
  reminderId: string;
  classId: string;
  teacherId: string;
  message: string;
  reminderAt: string | null;
  finalReminderTime: number;
  softReminderTime: number | null;
  selectedStudents: string[];
  targetAllStudents: boolean;
  createdAt: number;
  updatedAt: number;
  status: 'active' | 'cancelled';
};

export type ReminderResponse = {
  status: ReminderStatus;
  snoozeCount: number;
  actionTime: number | null;
};

export const MAX_REMINDERS = 5;
export const MAX_MESSAGE_LENGTH = 200;
export const MAX_SNOOZE_COUNT = 2;
export const SNOOZE_DELAY_MS = 5 * 60 * 1000;
export const POPUP_MIN_DISPLAY_MS = 10 * 1000;
